import axios from 'axios';

export function myGet(dispatch, url, options = {}) {
  dispatch({type: "FETCHING_DATA_STATE", state: true});
  return axios.get(url, options);
}

export function myPost(dispatch, url, data) {
  dispatch({type: "SAVING_DATA_STATE", state: true});
  return axios.post(url, data);
}

export function handleGetError (dispatch, err) {
  dispatch({type: "FETCHING_DATA_STATE", state: false});
  dispatch({
    type: "ADD_FLASH_MESSAGE",
    message: {
      type: 'error',
      text: 'Ошибка загрузки данных'
    }
  });
  console.log(err);
}

export function handlePostError (dispatch, err, cb) {
  dispatch({type: "SAVING_DATA_STATE", state: false});
  cb(err.response.data.errors || {form: 'Ошибка ' + err.response.status});
}



// WEBPACK FOOTER //
// ./src/utils/myAxios.js